import React from 'react';

const SchoolHeader = (props) => {
  return (
    <div className="container">
      <div className="school__header">
        <h1>{props.title}</h1>
        <h3>{props.subheader}</h3>
        <p>{props.subtitle}</p>
      </div>
    </div>
  );
};
export default SchoolHeader;
